import {getAxiosInstance} from "../../../np-rest/rest";
import {snackActions} from "../../../sc-utilities/SnackBar";

export const fetchDiagnoseCount = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let countRes = await rest.post("/diagnose-case-round/count-results", filterData);
            if (countRes.data && countRes.data.succeeded && countRes?.data?.result?.data ) {
                return countRes.data.result.data;
            }
            if (!countRes.data || !countRes.data.succeeded) {
                snackActions.snackBar({
                    message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch diagnoses."}`,
                    options: {
                        variant: 'warning'
                    }
                });
            }
            return 0;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnoses."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchDiagnoseList = filterData => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post("/diagnose-case-round/list-results", filterData);
            if (res.data && res.data.succeeded && res?.data?.result?.data) {
                return res.data.result.data || [];
            }
            if (!res.data || !res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : "Cannot fetch diagnoses."}`,
                    options: {
                        variant: 'warning'
                    }
                });
            }
            return [];
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch diagnoses."}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    }
}
